interface Props {
  title: string;
  subline?: string;
}

const PageTitle = ({ title, subline }: Props) => (
  <div className="w-full text-center">
    <h2 className="text-3xl font-semibold text-slate-900 sm:text-4xl">{title}</h2>
    {subline && (
      <p className="mx-auto mt-2 max-w-2xl text-sm text-slate-600">{subline}</p>
    )}
  </div>
);

export default PageTitle;
